import table from "./table.json";

export default {
  table,
};
